import React, { useEffect } from 'react'
import HeaderSec from '../../HeaderSec/HeaderSec'
import FooterComp from '../FooterComp'
import FooterSecComp from '../FooterSecComp'
import { Typography } from '@mui/material'
import reportnpo from '../../../Assets/img/Rrport an NPO other legal lapses.png'

const ReportNpo = () => {
    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

    const section1 = [
        'At GuideStar India, we are committed to upholding legal values not only in our organisation (Civil Society Information Services India) but also in the organisations that we feature on our platform. As a part of this commitment, we encourage transparency and accountability from our NPO partners, collaborators, our team, and the wider community, especially their legal obligations.',
        'All our stakeholders and well-wishers are responsible for upholding and promoting the highest standards of legal conduct and compliance. Any lapses in practising these standards, even if unintentional, may compromise the trust-based framework we envisage for our sector.',
        'We want to hear from you if you have observed or experienced any legal lapses at an organisation featured on our platform or within our organisation itself. Your report will help us ensure that our partners and we continue aligning with our values and maintaining the highest standards of conduct.'
    ]

    const section2 = [
        'Please note that we will treat all reports with the utmost confidentiality and sensitivity and urge you to do so. If you prefer to remain anonymous, you may submit your report without including your name and contact information. However, we encourage you to provide your details so we can follow up with you for additional information or clarification. We expect any issues brought to our attention to be reported as good faith efforts to address legitimate issues and concerns or provide reliable information. Our systems and processes are not and may not be construed as alternatives to India’s legal system or law enforcement.',
        'Upon receiving your report, our team will review the information and may take appropriate action as deemed necessary.',
        'We are grateful for your assistance in maintaining the highest legal standards within our featured organisations, our organisation and the sector. Together, we can create a more trusted and transparent social sector.'
    ]

    const points1 = [
        "Your name and contact information (optional but encouraged for follow-up)",
        "The name of the organisation involved and its GSN or PAN or Darpan ID",
        "A detailed description of the content (with page URL), incident or concern, including dates, locations, and any individuals involved",
        "Any supporting evidence or documentation, if available"
    ]

  return (
    <div className='max-w-screen overflow-hidden text-black'>
        <HeaderSec/>
        <div className='max-w-[1200px] m-auto min-h-[500px]'>
            <FooterSecComp
                topic={"REPORT AN NPO/ NGO/ LEGAL CONCERNS"}
                // header={'Reporting an NPO/ NGO/ Other Legal Concerns'}
                section={section1}
                image={reportnpo}
            />
            <FooterSecComp
                pointHead={'To report an issue, please follow these steps:'}
            />
            <Typography variant='h3'  sx={{fontSize:'15px' , fontWeight:400 , margin:' 0 0 10px 0' , textAlign:'justify' , lineHeight:1.6}}>
                Email us at <a href="mailto:" className='text-blue-600'>info@guidestarindia.org</a>  with the subject line “Legal Concern Report.”
            </Typography>
            <FooterSecComp
                pointHead={'In your email, please provide the following information:'}
                points={points1}
                section={section2}
            />
        </div>

        <FooterComp/>
    </div>
  )
}

export default ReportNpo